import React from 'react'
import { Value } from '../../elements'
import { formatPhoneForDemo } from 'src/lib/demo-privacy'

export const getMobileFields = () => [
  {
    key: 'name',
    label: 'ФИО',
    render: val => <Value data={val} />,
  },
  {
    key: 'phone',
    label: 'Телефон',
    render: val => formatPhoneForDemo(val),
  },
  {
    key: 'email',
    label: 'E-mail',
    render: val => <Value data={val} />,
  },
  {
    key: 'office_name',
    label: 'Офис',
    render: val => <Value data={val} />,
  },
]
